/**
 * View component for /site-locations/:siteLocationId
 *
 * Displays a single siteLocation from the 'byId' map in the siteLocation reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as siteLocationActions from '../siteLocationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import siteLocation components
import SiteLocationLayout from '../components/SiteLocationLayout.js.jsx';

// import siteLocation css modules
import siteLocationStyles from '../siteLocationModuleStyles.css';


class SingleSiteLocation extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(siteLocationActions.fetchSingleIfNeeded(match.params.siteLocationId));
  }

  render() {
    const { siteLocationStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual siteLocation object from the map
     */
    const selectedSiteLocation = siteLocationStore.selected.getItem();

    const isEmpty = (
      !selectedSiteLocation
      || !selectedSiteLocation._id
      || siteLocationStore.selected.didInvalidate
    );

    return (
      <SiteLocationLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single Site/Team Location </h3>
              {isEmpty ?
                (siteLocationStore.selected.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: siteLocationStore.selected.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedSiteLocation.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Site/Team Location </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the SiteLocation would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </SiteLocationLayout>
    )
  }
}

SingleSiteLocation.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    siteLocationStore: store.siteLocation
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleSiteLocation)
);



// WEBPACK FOOTER //
// modules/siteLocation/views/SingleSiteLocation.js.jsx